import * as React from "react";

const Ciphers: React.FunctionComponent = () => {
    return (
        <p>Ciphers (WIP)</p>
    );
};

export default Ciphers;